import { Component, OnInit } from '@angular/core';
import { DwAction, DwActionButtonComponent, DwActionFunc, DwActionPreference, DwActionType, DwComponent, DwComponentType, DwDecoratorType, DwFilterItemBase, DwFilterType, DwGridActionConfig, DwMenuService, DwMetaDataFilterConfigData, DwMetaDataFilterService, DwMetaDataFilterStateService, DwOperator, DwQueryHelper, DwUiConfigContextBase, getParameterByName } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, FlightSchoolOrganizationEntity, PilotExaminerEntity } from '../../../../meta-data/app-meta-data.service';
import { Router } from '@angular/router';
import { SchoolTaskDefinition, SchoolTaskService } from '../../services/school-task-service.service';
import { SchoolRepositoryService } from '../../services/school-repository.service';

@DwAction<DwGridActionConfig>({
  keyName: 'school-student-task-filter-action',
  display: 'School Student Task Filter',
  actionType: DwActionType.gridAction,
  decoratorType: DwDecoratorType.component,
  //configComponent: DwGridQuickSearchConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.FlightSchoolApplicant,
  allowOnce: true
})
@Component({
  selector: 'app-school-student-task-filter',
  template: `
      <div class="pull-right">
        <div class="dw-chip" [hidden]="!showChip">
            <div class="dw-chip-label-with-remove no-wrap">{{taskText}}</div>
            <div class="dw-chip-icon" (click)="clearItem()"><i class="fa fa-times-circle"></i></div>
        </div>
      </div>
  `
})
export class SchoolStudentTaskFilterComponent implements DwActionButtonComponent {

  showChip: boolean = false;
  actionPreference: DwActionPreference<any, any>;
  actionContext?: DwUiConfigContextBase;
  taskDef: SchoolTaskDefinition;

  taskText = '?????';
  constructor(private schoolTaskService: SchoolTaskService,
    private router: Router,
    private schoolRepositoryService: SchoolRepositoryService,
    private dwFilterStateService: DwMetaDataFilterStateService
  ) {
  }

  clearItem() {
    this.showChip = false;

    this.clearFilter();
  }

  setupComponent() {
    const filterTask = getParameterByName(this.router, 'filter');

    if (!filterTask) {
      return;
    }

    if (filterTask == 'recent_applicants') {
        this.taskText = 'Applicants Recently Submitted';

        this.showChip = true;

        const filter = this.buildFilter(AppMetaData.FlightSchoolApplicant.Attributes.PublicPortalSubmission.fieldName, true);
        const filter2 = this.buildFilter(AppMetaData.FlightSchoolApplicant.Attributes.CreatedDateTime.fieldName, -7, DwFilterType.GreaterThanEqualDays);

        const filterFilter = {
          ...filter,
          ...filter2
        };

        setTimeout(() => {
          this.applyFilters(filterFilter);
        }, 100);
    }
  }

  setupFilter(flightSchool: FlightSchoolOrganizationEntity) {
    const scheuledCheckrides = flightSchool.CheckRideRequest.filter((checkride) => this.schoolTaskService.isScheduledCheckride(checkride));

    const currentCheckrideRequests = scheuledCheckrides.filter((checkride) => this.taskDef.filterFunc(checkride));

    const checkrideIds = currentCheckrideRequests.map((checkride) => checkride.CheckRideRequestId);

    if (checkrideIds.length == 0) {
      checkrideIds.push(-1);
    }

    const newFilter = this.buildFilter('CheckRideRequestId', checkrideIds, DwFilterType.In);

    this.applyFilters(newFilter);
  }

  clearFilter() {
    this.applyFilters({});
  }

  private applyFilters(newFilter: any) {
    const allFilters = this.dwFilterStateService.state.filters || {};

    allFilters['GroupSchoolTaskFilter'] = newFilter;

    const preserveFilters = {};

    preserveFilters['GroupSchoolTaskFilter'] = newFilter;

    console.log('Applying filters', newFilter);

    this.dwFilterStateService?.setFilters(allFilters, null, null, true, preserveFilters);
  }

  private buildFilter(attrName: string, value: any, filterType: DwFilterType = DwFilterType.Equal): any {
    const qh = new DwQueryHelper();

    const filterTypeKey = qh.convertFilterType(filterType);
    const filter: any = {
      Op: DwOperator.And
    };

    // Use the display attribute name which works for text as well as lookups
    const attrFilter: any = filter[attrName] = {};

    //attrFilter.Prefix = attr.RelationPrefix;
    attrFilter[filterTypeKey] = value;

    return filter;
  }
}